import { stdObject } from "../../../data/types/stdObject";
import { updateRowData } from "../../../store/updateData";

export const updateInternalPerson = (
  jsonData: stdObject,
  type: string,
  dispatch: any,
) => {
  let { data, address, deleteCode } = jsonData;
  address = address.map((v: stdObject) => {
    delete v.ID_DIR;
    return v;
  });
  data = [{ ...data, [`DOM${type}`]: address.length === 0 ? "" : address }];
  if (deleteCode) data.push({ deleteCode });
  dispatch(updateRowData({ type, data }));
  return data[0];
};
